export default __webpack_public_path__ + "static/media/call-duty.ffd1f3ab.png";